import { render } from "./ContactInfoView.vue?vue&type=template&id=3534a5d4&scoped=true&ts=true&lang=pug"
import script from "./ContactInfoView.vue?vue&type=script&lang=ts"
export * from "./ContactInfoView.vue?vue&type=script&lang=ts"

import "./ContactInfoView.vue?vue&type=style&index=0&id=3534a5d4&lang=scss&scoped=true"

import exportComponent from "/Users/danielwu/Documents/bearathome/bat-project/bat-org-manage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3534a5d4"]])

export default __exports__